var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreditCard03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 6.5H1M1 4.7L1 12.3C1 13.4201 1 13.9802 1.21799 14.408C1.40973 14.7843 1.71569 15.0903 2.09202 15.282C2.51984 15.5 3.07989 15.5 4.2 15.5L17.8 15.5C18.9201 15.5 19.4802 15.5 19.908 15.282C20.2843 15.0903 20.5903 14.7843 20.782 14.408C21 13.9802 21 13.4201 21 12.3V4.7C21 3.5799 21 3.01984 20.782 2.59202C20.5903 2.2157 20.2843 1.90974 19.908 1.71799C19.4802 1.5 18.9201 1.5 17.8 1.5L4.2 1.5C3.0799 1.5 2.51984 1.5 2.09202 1.71799C1.7157 1.90973 1.40973 2.21569 1.21799 2.59202C1 3.01984 1 3.57989 1 4.7Z",
    stroke: "#344054",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreditCard03);
export default __webpack_public_path__ + "static/media/credit-card-03.baa5c7d16fe491d53083894cc66780aa.svg";
export { ForwardRef as ReactComponent };